import { NavDropdown } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";
import { formatText } from "util/helper";
import classes from "./GrandChildrenMenuMobile.module.css";

const GrandChildrenMenuMobile = ({
  childItem,
  showModalsHandler,
  modalContents,
  setNavOpen,
}) => {
  return (
    <NavDropdown
      title={<FormattedMessage id={formatText(childItem.title)} />}
      id="nav-dropdown-1"
      onClick={() => {
        showModalsHandler(childItem);
      }}
      className={classes["grandchild-mobile-menu"]}
    >
      {modalContents
        ? modalContents.map((content, index) => (
            <div
              className={`col-lg-4 ${
                childItem.title === "Software Solution"
                  ? classes["modal-container--software"]
                  : classes["modal-container--hardware"]
              }`}
            >
              <div className="text-wrapper">
                <h5
                  className={`${content.color} ${
                    childItem.title === "Software Solution"
                      ? "software"
                      : "hardware"
                  }`}
                >
                  {content.title}
                </h5>
                {content.imgUrl ? (
                  <img
                    src={content.imgUrl}
                    alt="solution"
                    className={classes.img}
                  />
                ) : null}
                <p>{content.contents}</p>
                {content.contents2 ? <p>{content.contents2}</p> : null}
              </div>
              <Link
                to={content.link}
                className={`${content.color}-button`}
                onClick={() => setNavOpen(false)}
              >
                {content.buttonText}
              </Link>
            </div>
          ))
        : null}
    </NavDropdown>
  );
};

export default GrandChildrenMenuMobile;
